import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { IUbicacionConId } from '../polygon-draw.component';

@Component({
  selector: 'app-polygonos',
  templateUrl: './polygonos.component.html',
  styleUrls: ['./polygonos.component.scss'],
})
export class PolygonosComponent implements OnInit, OnChanges {
  @Input() ubicaciones: IUbicacionConId[] = [];
  @Input() polygonOptions: google.maps.PolygonOptions[] = [];
  public circleOptions: google.maps.CircleOptions[] = [];
  @Input() cLinea?: string;
  @Input() cRelleno?: string;
  @Input() opacidad?: number;
  @Input() onPolygonClick?: (ubicacionId: string) => void;

  constructor() {}

  createPolygons() {
    this.polygonOptions = [];
    this.circleOptions = [];
    console.log('Ubicación procesada:', this.ubicaciones);

    for (const ubicacion of this.ubicaciones) {
      if (!ubicacion.circulo) {
        const polygonOptions: google.maps.PolygonOptions & { _id?: string } = {
          paths: ubicacion.poligono,
          strokeColor: ubicacion.colorPrediccion || this.cLinea || '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: ubicacion.colorPrediccion || this.cRelleno || '#FF0000',
          fillOpacity:
            this.opacidad || this.opacidad === 0 ? this.opacidad : 0.35,
          zIndex: -1,
          clickable: true,
          draggable: false,
          editable: false,
          _id: ubicacion._id,
        };
        this.polygonOptions.push(polygonOptions);
      } else {
        const circleOptions: google.maps.CircleOptions & { _id?: string } = {
          center: ubicacion.circulo.centro,
          radius: ubicacion.circulo.radio,
          strokeColor: ubicacion.colorPrediccion || this.cLinea || '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: ubicacion.colorPrediccion || this.cRelleno || '#FF0000',
          fillOpacity: this.opacidad || 0.35,
          zIndex: -1,
          clickable: true,
          draggable: false,
          editable: false,
          _id: ubicacion._id,
        };
        this.circleOptions.push(circleOptions);
      }
    }
  }

  // Manejar click en polígono
  handlePolygonClick(event: google.maps.PolyMouseEvent, polygon: any): void {
    console.log('Polygon clicked:', polygon);
    if (this.onPolygonClick && polygon._id) {
      this.onPolygonClick(polygon._id);
    }
  }

  // Manejar click en círculo
  handleCircleClick(event: google.maps.MapMouseEvent, circle: any): void {
    if (this.onPolygonClick && circle._id) {
      this.onPolygonClick(circle._id);
    }
  }

  ngOnChanges() {
    this.createPolygons();
  }

  ngOnInit(): void {}
}
